import React, { useContext } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import MyContext from "../../../StoreContext";
import { URL_BASE } from "../../../App";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70vw",
  height: "auto",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 1,
  borderRadius: "65px",
};

/**
 * Componente modal que muestra la imagen de la plataforma
 * en donde se puede ver la respuesta automatica
 */
const PlatformModal = () => {
  const { openModal, updateOpenModal, industry, platform, message } =
    useContext(MyContext);

  const handleClose = () => updateOpenModal(false);

  return (
    <div>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <img
            src={`${URL_BASE}/response/${industry}/${platform}/${message}.webp`}
            alt='gmail max'
            style={{
              maxWidth: "100%",
              height: "auto",
            }}
          />
        </Box>
      </Modal>
    </div>
  );
};

export default PlatformModal;
